import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessOverviewRedirectRoute: InvariantJiraRoute = {
	name: 'classic-business-overview-redirect',
	path: '/jira/core/overviews/:overviewId',
	exact: true,
};
